var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['text lh-small white--text', { 'text--compact': _vm.compact }]},[_c('div',[_vm._v("dicom")]),_c('div',[_vm._v("vision")])])
}
var staticRenderFns = []

export { render, staticRenderFns }